export default "__VITE_ASSET__CgTCf8cf__"